import platform from '@tencent/wphk-platform-adapter';

/** Cookie 名称常量 */
export const COOKIE_NAME_WALLET_OPENID = 'wallet_openid';
export const COOKIE_NAME_QL_UIN = 'qluin';

/** 从 cookie 获取 UIN */
export function getUin() {
  const wphkUin = platform.getCookie(COOKIE_NAME_WALLET_OPENID);
  const qlUin = platform.getCookie(COOKIE_NAME_QL_UIN);
  return wphkUin || qlUin;
}
